(function () {
  function defineProductModal() {
    if (customElements.get('product-modal')) return true;

    const ModalDialogBase = window.ModalDialog || customElements.get('modal-dialog');
    if (!ModalDialogBase) return false;

    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialogBase {
        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          const mediaId = this.openedBy?.getAttribute('data-media-id');
          if (!mediaId) return;

          this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
            element.classList.remove('active');
          });

          const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
          if (!activeMedia) return;

          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent?.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }
    );

    return true;
  }

  if (!defineProductModal()) {
    customElements.whenDefined('modal-dialog').then(defineProductModal);
  }
})();
